<template>
  <div id="app" v-loading="$store.state.api_loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  mounted() {
    
  }

}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
/* 手机端 */
#app,
body,
html {
  max-width: 768px;
  margin: auto;
}
#app {
  max-width: 480px;
}

</style>
